export const LIST_PRODUCT_CROSS_SELL = 'LIST_PRODUCT_CROSS_SELL';
export const CREATE_PRODUCT_CROSS_SELL = 'CREATE_PRODUCT_CROSS_SELL';
export const DELETE_PRODUCT_CROSS_SELL = 'DELETE_PRODUCT_CROSS_SELL';
export const DELETES_PRODUCT_CROSS_SELL = 'DELETES_PRODUCT_CROSS_SELL';
export const UPDATE_PRODUCT_CROSS_SELL = 'UPDATE_PRODUCT_CROSS_SELL';
export const SHOW_PRODUCT_CROSS_SELL = 'SHOW_PRODUCT_CROSS_SELL';
export const RELOAD_PRODUCT_CROSS_SELL = 'RELOAD_PRODUCT_CROSS_SELL';